import { KeyValueModel } from "model/api";
import { EnumTpDescontoAcrescimo } from 'model/enums/enum-tp-desconto-acrescimo';

export const TpAcresDescMock: KeyValueModel[] = [
    new KeyValueModel(EnumTpDescontoAcrescimo.Porcentagem, "%"),
    new KeyValueModel(EnumTpDescontoAcrescimo.ValorFixo, "R$"),
];
